import { Timeframe } from "../enums/timeframe.enum";

/**
 * Market phase based on Auction Market Theory
 */
export enum AmtMarketPhase {
  BALANCE = "BALANCE",
  IMBALANCE = "IMBALANCE",
}

/**
 * Type of liquidity event detected
 */
export enum AmtLiquidityType {
  STOP_RUN = "STOP_RUN",
  LIQUIDITY_GRAB = "LIQUIDITY_GRAB",
  FLIP = "FLIP",
  MAGNET = "MAGNET",
  BARRIER = "BARRIER",
}

export type AmtAction = "BUY" | "SELL";

export type MarketTimeframe = "1d" | "1w" | "1M" | "3M" | "1Y";

export interface AuctionMarketEvent {
  symbol: string;
  pair: string;
  exchange: string;
  timeframe: Timeframe;
  timestamp: number;
  action: AmtAction;
  phase: AmtMarketPhase;
  liquidityType: AmtLiquidityType;
  confidence: number;
  marketTimeframe: MarketTimeframe;
  marketPeriodStart: number;
  marketPeriodEnd: number;
  valueAreaHigh: number;
  valueAreaLow: number;
  poc: number;
  volumeRatio: number;
  priceRecovery: number;
  isHighTimeframeTrendAligned: boolean;
}
